"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sideNavSections = void 0;
var routes_1 = require("../constants/routes");
exports.sideNavSections = [
    {
        items: [
            {
                label: "Task Dashboard",
                icon: "solar:checklist-linear",
                to: routes_1.ROUTES.TASKS_DASHBOARD,
            },
            {
                label: "Facility Dashboard",
                icon: "solar:chart-2-linear",
                to: routes_1.ROUTES.FACILITY_DASHBOARD,
            },
            { label: "Alarms", icon: "solar:bell-linear", to: routes_1.ROUTES.ALARMS, badge: "ACTIVE_ALARMS" },
            {
                label: "Grow Cycles",
                icon: "solar:leaf-linear",
                to: routes_1.ROUTES.GROW_CYCLES,
            },
            {
                label: "Devices",
                icon: "solar:cpu-bolt-linear",
                to: routes_1.ROUTES.DEVICES,
            },
            {
                label: "Quality Management",
                icon: "solar:shield-check-linear",
                children: [
                    { label: "SOP Library", icon: "solar:notebook-linear", to: routes_1.ROUTES.SOP_LIBRARY },
                    { label: "Area Libraries", icon: "solar:folder-linear", to: routes_1.ROUTES.AREA_LIBRARIES },
                ],
            },
            {
                label: "User Management",
                icon: "solar:users-group-rounded-linear",
                children: [
                    { label: "Users", icon: "solar:user-linear", to: routes_1.ROUTES.USERS },
                    { label: "Administration", icon: "solar:shield-user-linear", to: routes_1.ROUTES.ADMINISTRATION },
                ],
            },
            {
                label: "Starting Material",
                icon: "mdi:cannabis",
                to: routes_1.ROUTES.STARTING_MATERIAL,
            },
            {
                label: "Mother Room",
                icon: "mdi:flower-outline",
                children: [
                    { label: "Registry", icon: "solar:list-linear", to: routes_1.ROUTES.MOTHER_ROOM, permission: "view_mother_plants" },
                    { label: "New Mother Plant", icon: "solar:add-circle-linear", action: "create-mother-plant", permission: "create_mother_plants" },
                ],
            },
            {
                label: "Facility Management",
                icon: "solar:buildings-2-linear",
                to: routes_1.ROUTES.FACILITY_MANAGEMENT,
            },
        ],
    },
    {
        label: "More",
        items: [
            {
                label: "Clients",
                icon: "solar:case-round-linear",
                children: [
                    { label: "Client List", icon: "solar:clipboard-list-linear", to: routes_1.ROUTES.CLIENT_LIST },
                    { label: "Invitations", icon: "solar:letter-linear", to: routes_1.ROUTES.CLIENT_INVITATIONS },
                ],
            },
            {
                label: "Settings",
                icon: "solar:settings-linear",
                children: [
                    { label: "Billing", icon: "solar:card-linear", to: routes_1.ROUTES.BILLING_SETTINGS, permission: "manage_billing" },
                    { label: "Permissions", icon: "solar:shield-keyhole-linear", to: routes_1.ROUTES.PERMISSIONS_SETTINGS, permission: "view_permissions" },
                ],
            },
            {
                label: "Integrations",
                icon: "solar:plug-circle-linear",
                to: routes_1.ROUTES.INTEGRATIONS,
            },
        ],
    },
];
